import 'select2';
import 'select2/select2-bootstrap.css';
import 'select2/select2.css';




// WEBPACK FOOTER //
// ./webpack/assets/javascripts/bundle_select2.js